import * as React from 'react';
import styled from 'styled-components';
import { backgroundImage, BackgroundImageProps } from 'styled-system';
import { themeGet, Text, Flex, Box, media } from '@packages/ui';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { SearchBarContainer } from '@packages/shared';
import { Translate } from '@packages/i18n';
import { ModuleSearch } from '@packages/common';

const ASSETS_URL = getPublicRuntimeConfig('ASSETS_URL');

const Container = styled(Flex)<BackgroundImageProps>`
  ${backgroundImage};
  background-size: 100% 100%;
  max-width: 1265px;
  margin: 0 auto;
  z-index: ${themeGet.zIndex('OVERLAY', 1)};
`;

const SearchContainer = styled(Box)`
  /* TODO: fix this later */
  div.search-input-container {
    width: calc(100% + 24px);
    max-width: calc(100% + 24px);
    position: relative;
    z-index: ${themeGet.zIndex('OVERLAY', 1)};
    top: 0;
    transform: translateY(0);
    ${media.from.lg`
      width: 100%;
      max-width: 100%;
    `}
  }
`;

export type SearchProps = ModuleSearch & {
  onSubmit?: (args: { query: string }) => void;
};

export const Search: React.FC<SearchProps> = () => {
  const grayBackground = `${ASSETS_URL}/static/images/sea-bg.jpg`;
  return (
    <Container
      p={[2, 3, 3]}
      justifyContent="center"
      alignItems="center"
      flexDirection={['column', 'column']}
      backgroundImage={`url(${grayBackground})`}
    >
      <Box width={[1, 1, 2 / 3]} p={[2, 3, 3]}>
        <Text tag="h2" textAlign="center" fontSize={[6, 8]} mt={0} mb={0}>
          <Translate translation="cmsModuleSearchText"></Translate>
        </Text>
      </Box>
      <SearchContainer width={[2 / 3]} p={[2, 3, 3]}>
        <SearchBarContainer showBackButton={false} showSlogan={false} testIdPrefix={'search-mixin'} />
      </SearchContainer>
    </Container>
  );
};
